module.exports = "/assets/data/ed2b6009ae92e4d4f2e40d63d2006192-NN18.data.json";